module.exports = __webpack_public_path__ + "img/01.70f1a6c9.png";